<template>
    <Modal class="popup_content" v-model="cancelorderShows" width="560" @on-cancel="cancelorderCancel">
        <div slot="header" class="popup_header_content">
            <span>取消原因</span>
        </div>
        <div class="popup_head_body">
            <Input v-model="cancelorderInfos" type="textarea" :rows="8" placeholder="请输入取消原因，最多100个字" :maxlength="100" :autofocus="true" />
        </div>
        <div slot="footer" class="popup_footer_content">
            <Button type="warning" size="large" @click="cancelorderOk">提交</Button>
        </div>
    </Modal>
</template>

<script>
    export default {
        props: ['cancelorderShow', 'cancelorderInfo'],
        data() {
            return {
                cancelorderShows: false,
                cancelorderInfos: ''
            }
        },
        methods: {
            cancelorderOk () {
                if (this.cancelorderInfos != '') {
                    this.cancelorderShows = false
                    this.$emit('cancelorderOk', this.cancelorderInfos)
                } else {
                    this.$Message.warning('请填写取消原因')
                }
            },
            cancelorderCancel () {
                this.cancelorderShows = false
                this.$emit('cancelorderCancel')
            }
        },
        watch: {
            cancelorderShow () {
                this.cancelorderShows = this.cancelorderShow
                this.cancelorderInfos = this.cancelorderInfo
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/component/popup/cancelorder.vue